import { connect } from 'react-redux';
import { checkedAllItems, onChange, onChangeClasses, onChangeItem, searchItemCode } from './../../../../../actions/addOrder';
import RowItemComponent from './../../../components/items/RowItemComponent';
import { getListItemName, onChangeItemName } from './../../../../../actions/getListItemName'
import './RowItem.css';

class RowItem extends RowItemComponent {}

const mapStateToProps = state => {
    return {
        classes: state.addOrder.classes,
        itemOrder: state.addOrder.items,
        order: state.addOrder,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeItem: payload => {
            dispatch(onChangeItem(payload))
        },
        onChange: payload => {
            dispatch(onChange(payload))
        },
        onChangeClasses: payload => {
            dispatch(onChangeClasses(payload))
        },
        searchItemCode: payload => {
            dispatch(searchItemCode(payload))
        },
        checkedAllItems: payload => {
            dispatch(checkedAllItems(payload))
        },
        getListItemName: payload => {
            dispatch(getListItemName(payload))
        },
        onChangeItemName: payload => {
            dispatch(onChangeItemName(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RowItem)



// WEBPACK FOOTER //
// ./src/containers/orders/add/components/items/RowItem.js